import { useQuery } from 'react-query'
import { getProductSetting } from './ProductTransform'

export const PRODUCT_SETTING_QUERY_KEY = 'GET_PRODUCT_SETTINGS'

export function useFreshProductSetting() {
  return useQuery(PRODUCT_SETTING_QUERY_KEY, getProductSetting, {
    refetchOnMount: 'always',
    staleTime: 0,
  })
}
